import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["tab", "panel"];

  connect() {
    // Set initial active tab if none is set
    if (!this.hasActiveTab()) {
      this.activateTab(0);
    }
  }

  switch(event) {
    event.preventDefault();
    const tabIndex = event.currentTarget.dataset.tabIndex;
    this.activateTab(parseInt(tabIndex));
  }

  activateTab(index) {
    // Deactivate all tabs and panels
    this.tabTargets.forEach((tab, i) => {
      if (i === index) {
        tab.classList.add("border-button-primary-bg", "text-primary-color");
        tab.classList.remove("border-transparent", "text-gray-400", "hover:text-gray-300");
      } else {
        tab.classList.remove("border-button-primary-bg", "text-primary-color");
        tab.classList.add("border-transparent", "text-gray-400");
      }
    });

    this.panelTargets.forEach((panel, i) => {
      if (i === index) {
        panel.classList.remove("hidden");
      } else {
        panel.classList.add("hidden");
      }
    });

    this.#activateBridgeFormInPanel(index);
  }

  hasActiveTab() {
    return this.tabTargets.some((tab) => tab.classList.contains("border-button-primary-bg"));
  }

  // Native navbar Guardar is owned by the last bridge--form that connected.
  // Re-bind it to the form inside the newly visible tab panel.
  #activateBridgeFormInPanel(index) {
    const panel = this.panelTargets[index];
    if (!panel) return;

    const formElement = panel.querySelector('[data-controller~="bridge--form"]');
    if (!formElement) return;

    const formController = this.application.getControllerForElementAndIdentifier(
      formElement,
      "bridge--form"
    );
    formController?.activate?.();
  }
}
